import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, inject, model, OnInit, signal, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ListGame } from '../../../shared/components/lists/list-game/list-game';
import { LinkRegistration } from '../../../shared/components/links/link-registration/link-registration';
import { AllStatus } from '../../../core/services/status/all-status';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ExitService } from '../../../core/services/exit/exit.service';
import { DowntimeWindow } from '../../../shared/dialogs/downtime-window/downtime-window';
import { map, Observable, of, startWith, Subscription, switchMap, timer, distinctUntilChanged } from 'rxjs';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { Downtime } from '../../../core/services/times/downtime';
import { ListGameService } from '../../../shared/services/lists/list-game';
import { AsyncPipe, NgClass } from '@angular/common';
import { LanguageService } from '../../../core/services/language/language.service';


@Component({
  selector: 'app-games-list',
  imports: [ListGame,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatCheckboxModule,
    FormsModule,
    TranslatePipe,
    MatAutocompleteModule,
    ReactiveFormsModule,
    AsyncPipe, NgClass],
  templateUrl: './games-list.html',
  styleUrl: './games-list.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GamesListComponent implements OnInit {
  activatedRoute = inject(ActivatedRoute);
  allStatus$ = inject(AllStatus);
  readonly dialog = inject(MatDialog);
  exit = inject(ExitService);
  subscription: Subscription;
  subscriptionCM: Subscription;
  subscriptionUL: Subscription;

  langService = inject(LanguageService);

  game = signal([]);
  gameCopy = signal([]);
  lists = inject(ListGameService);
  whenRefresh$ = timer(25000, 30000);
  
  isListEmpty: boolean = false;
  iconChange: boolean = false;

  @ViewChild('input') input: ElementRef<HTMLInputElement>;
  control = new FormControl('');
  filteredOptions: Observable<any[]>;

  router = inject(Router);
  downtime = inject(Downtime);

  readonly checked = model(false);

  constructor( private ref: ChangeDetectorRef){}

  ngOnInit(): void {
    this.iconChange = false;
    this.updateList();
    this.allStatus$.setUpdateListRoom(false);
    this.filteredOptions = this.control.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || '')),
    );

    this.subscription = this.allStatus$.downTime$.subscribe((follow: any)=>{
      if(follow){
        const dialogConfig = new MatDialogConfig();
        dialogConfig.panelClass = 'nutri-templs';
        dialogConfig.backdropClass = 'nutri-templs-backdrop';
        
        const dialogRef = this.dialog.open(DowntimeWindow, dialogConfig);
        dialogRef.afterClosed().subscribe(result=>{
            this.exit.exitSystem();
        });
      }
    });
    this.allStatus$.valueSearchList.subscribe((value: string)=>{
      if(value.length !== 0){
        this.isListEmpty = false;
        this.control.setValue('');
        this.input.nativeElement.value = '';
        this.filteredOptions = of([]);
        this.iconChange = false;
        this.updateList();       
      }
    });
    this.allStatus$.updateListRoom.subscribe((value: boolean)=>{
      if(value){
        this.updateList();
        this.allStatus$.setUpdateListRoom(false);
      }
    });
    this.subscriptionCM = this.allStatus$.refreshNotValid$.subscribe((action: boolean)=>{
      if(action){
        this.exit.closeSystem();
      }
    });
    this.updateAllInfo();
  }

  ngOnDestroy(): void {
    if(this.subscription){
      this.subscription.unsubscribe();
    }
    if(this.subscriptionCM){
      this.subscriptionCM.unsubscribe();
    }
    if(this.subscriptionUL){
      this.subscriptionUL.unsubscribe();
    }
  }

  clearFilter(){
    this.allStatus$.textSpinner = (this.langService.appLanguage === 'uk')?'Завантаження списку кімнат...':(this.langService.appLanguage === 'ru')?'Загрузка списка комнат...':'Loading room list...';
    this.allStatus$.setDisplayProgressSpinner(true);
    this.isListEmpty = false;
    this.control.setValue('');
    this.input.nativeElement.value = '';
    this.filteredOptions = of([]);
    this.iconChange = false;
    this.updateList();       
  }

  updateList(){
    this.lists.getListRooms(this.checked()).subscribe((list:any)=>{
       this.allStatus$.setValueSearchList('');
      this.game.set(list.rooms);
      this.gameCopy.set(list.rooms);
      this.allStatus$.setDisplayProgressSpinner(false);
      this.allStatus$.textSpinner = '';      
      this.ref.markForCheck(); 
    });
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    this.iconChange = (filterValue.length >= 1);
    return (filterValue.length >= 1) ? this.gameCopy().filter((o:any) =>  o.name.toLowerCase().includes(filterValue)):[];
  }

  updateAllInfo(){
       this.subscriptionUL = this.whenRefresh$.pipe(
        switchMap(() => this.lists.getListRooms(this.checked())),
        distinctUntilChanged((prev: any, curr: any) => 
          JSON.stringify(prev?.rooms) === JSON.stringify(curr?.rooms)
        )
      ).subscribe((list:any) =>{      
        if(!this.isListEmpty){
          this.game.set(list.rooms);
          this.gameCopy.set(list.rooms);
          this.ref.markForCheck();
        } 
      });
    }

  filter(): void {
    const filterValue = this.input.nativeElement.value.toLowerCase();
    if(filterValue.length !== 0 ){
      let rooms = this.gameCopy().filter((o:any) =>  o.name.toLowerCase().includes(filterValue) );
      this.game.set(rooms);
      this.isListEmpty = true;
    }else{
      if(this.isListEmpty){
        this.allStatus$.textSpinner = (this.langService.appLanguage === 'uk')?'Завантаження списку кімнат...':(this.langService.appLanguage === 'ru')?'Загрузка списка комнат...':'Loading room list...';
        this.allStatus$.setDisplayProgressSpinner(true);
        this.updateList();
        this.isListEmpty = false;
      }
      //this.allStatus$.setValueSearchList('');
    }
  }

  showInput(){
    let show: boolean = true;
    if(!this.isListEmpty){
      if(this.game().length <= 4 ){
        show = false;
      }
    }
    return show;
  }

  statysMobile(){
    let isShow = 'show-mobile';
    if(this.game().length === 0){
      isShow = 'hide-mobile';
    }
    return isShow;
  }

  goToPrev(){
    this.downtime.refreshTimer();
    this.router.navigate(['/step-two']);
  }
}
